<template>
  <div>
    <div class="row vertical-align-center">
      <div class="col-sm-5">
        <div class="row vertical-align-center">
          <div class="dataTables_length col-sm-4" id="example1_length">
            <label>Show
              <select v-on:change="showSizeChange" name="example1_length" aria-controls="example1" class="form-control input-sm">
                <!--<option value="2">2</option>-->
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select> entries
            </label>
          </div>
          <button type="button" v-on:click="openModal()" class="btn btn-primary">New user</button>
        </div>
      </div>
    </div>

      <div class="row">
        <div class="col-sm-12 table-responsive">

          <table role="grid" class="table table-bordered table-striped dataTable">
            <thead>
              <tr role="row">
                <th v-on:click="sortBy('creationDate','true')" v-bind:class="{ active: sortField === 'creationDate' }" aria-label="Creation date" aria-sort="ascending" colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="sorting_asc">Creation Date</th>
                <th aria-label="Name" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Name</th>
                <th aria-label="Firstname" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Firstname</th>
                <th aria-label="Username" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Username</th>
                <th aria-label="Username" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Role</th>
                <th aria-label="" colspan="1" rowspan="1" aria-controls="example1" tabindex="0"></th>
              </tr>
            </thead>
            <div v-if="users.length === 0" class="no-data">No data found</div>
            <tbody v-else>
              <tr class="even" role="row" v-for="user in users" v-bind:key="user._id">
                <td class="sorting_1">{{user.creationDate | prettyDateTime}}</td>
                <td>{{user.lastName}}</td>
                <td>{{user.firstName}}</td>
                <td>{{user.username}}</td>
                <td>{{user.role}}</td>
                <td><i data-toggle="tooltip" data-placement="bottom" title="Remove User" class="fa fa-close clickable" v-on:click="confirmRemoveUser(user._id)"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row" v-if="users.length > 0">

        <div class="align-infos col-sm-12">
            <div class="dataTables_info" id="example1_info" role="status" aria-live="polite">Showing 
              {{total - users.length + 1 > page * size + 1 ? page * size + 1 : total - users.length + 1}}
              to {{total > (page + 1) * size ? (page + 1) * size:total}} of {{total}} entries
            </div>
        </div>
        <div class="table-pagination col-sm-12">

          <paginate
            :page-count="pageTotal"
            :page-range="3"
            :margin-pages="2"
            :click-handler="changePage"
            :prev-text="'Prev'"
            :force-page="page"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
          
        </div>
      </div>
      <confirm-modal message="Do you really want to delte this user ?" title="Delete Confirmation" @confirm="remove()" id="ConfirmModal"></confirm-modal>
    </div>
</template>

<script>
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import api from '../../api'

export default {
  name: 'UsersList',
  props: [],
  data () {
    return {
      users: [],
      toDelete: null,
      size: 10,
      pageTotal: 0,
      total: 0,
      page: 0,
      sortField: 'creationDate',
      desc: 'true'
    }
  },
  methods: {
    remove () {
      api.authenticatedRequest('delete', `/users/${this.toDelete}`)
      .then(response => {
        this.toDelete = null
        this.refresh()
      })
      .catch(error => {
        console.log(error)
      })
    },
    confirmRemoveUser (toDelete) {
      this.toDelete = toDelete
      window.jQuery('#ConfirmModal').modal({})
    },
    openModal () {
      this.$emit('openModal')
    },
    sortBy (sortField, desc) {
      this.sortField = sortField
      this.desc = desc
      this.refresh(true)
    },
    changePage (pageNum) {
      this.page = pageNum - 1
      this.refresh()
    },
    showSizeChange (e) {
      this.size = e.target.value
      this.refresh(true)
    },
    refresh (toFirstPage = false) {
      if (toFirstPage) {
        this.page = 0
      }
      this.getUsers()
    },
    getUsers () {
      /* Making API call to authenticate a user */
      api.authenticatedRequest('get', `/users?size=${this.size}&page=${this.page}&sortField=${this.sortField}&desc=${this.desc}`)
      .then(response => {
        const data = response.data
        this.users = data.data
        this.total = data.total

        this.pageTotal = parseInt(this.total / this.size) + 1
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 401) { // InvalidCredentialsError
          this.response = 'Username/Password incorrect. Please try again.'
          return
        }
        this.response = 'Server appears to be offline'
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.refresh()
    })
  }
}
</script>
<style>

@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

table.dataTable thead {
  cursor: default;
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'Font Awesome 5 Free';
}

table.dataTable thead .sorting_asc:focus,
table.dataTable thead .sorting_desc:focus {
  outline: none;
}

table.dataTable thead .active:after {
    opacity: 0.5!important;
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
  opacity: 0.2;
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
  opacity: 0.2;
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
  opacity: 0.2;
}

table.dataTable td {
  cursor: pointer;
}

table.dataTable tbody tr:hover {
  background-color: #eee;
}

table.dataTable .no-data {
  text-align: center;
  height: 37px;
  display: table-caption;
  caption-side: bottom;
  padding-top: 7px;
}

.dataTables_length label {
  margin: 0;
}

.date-control {
  border:0
}

.dataTables_filter {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}

.dataTables_filter button {
  height: 100%;
  border-top-right-radius:3px !important;
  border-bottom-right-radius:3px !important;
}

.filters-row {
  margin-left: -11px;
  margin-right: -11px;
} 

.filters {
  padding-top: 10px;
  padding-bottom: 10px;
}

.filters button {
  height: 30px;
}

.vertical-align-center {
  display: flex;
  align-items: center;
}

.filter-btn {
  justify-content: center !important;
  margin: auto !important;
}

.search-btn:active:focus,
.filter-btn:active:focus {
  outline: none;
}

.vdp-datepicker input {
  border: 1px solid #d2d6de;
}

.search-table {
  height: 34px;
}

.dataTables_filter input {
  border-top-left-radius:3px !important;
  border-bottom-left-radius:3px !important;
  height:auto !important;
  line-height: 1.45 !important;
  color:#555 !important;    
  background-color:#fff !important;
  border:1px solid #ccc !important;
  transition:border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  display:inline-block !important;
  padding:6px 12px !important;
  margin-bottom:0 !important;
  font-size:14px !important;
  font-weight:400 !important;
  white-space:nowrap !important;
  vertical-align:middle !important;
  width:50% !important;
  margin-right: -1px;
}

.align-infos {
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
    text-align: end;
}

.pagination {
  margin-top: 0;
  display: inline-flex;
  justify-content: center;
}

.table-pagination {
    display: flex;
    justify-content:  center;
}
</style>



// WEBPACK FOOTER //
// UsersList.vue?5c4f0d2e